import { useState } from 'react'
import imagecover from '../asset/images/imgover.png'
import imagecover2 from '../asset/images/6.png'
import imagecover3 from '../asset/images/10.png'
import imagecover4 from '../asset/images/15.png'
import { useSpring, animated } from 'react-spring';

import { getAllProject } from '../firebase'

import { useEffect } from 'react'
import { useDarkMode } from "../DarkModeContext";


const initialData = [
    {
        name: "Duy Thanh",
        position: "Dev"
    },
    {
        name: "Nguyen Duy",
        position: "Designer"
    },
    {
        name: "Wang",
        position: "Back-end"
    },
    {
        name: "Huynh Tuan",
        position: "Front-end"
    },
    {
        name: "Duck Vinh",
        position: "Tester"
    },
    {
        name: "Th4i",
        position: "DevObs"
    },
    {
        name: "Trong Tai",
        position: "Security"
    },
    {
        name: "Phat",
        position: "BA"
    }
]

const initialDataLG = [
    {
        nameLang: "JavaScript",
    },
    {
        nameLang: "PHP",
    },
    {
        nameLang: "NodeJS",
    },
    {
        nameLang: "ReactJS",
    },
    {
        nameLang: "Dart",
    },
    {
        nameLang: "Ruby",
    }
]

const initialDataDB = [
    {
        nameDB: "Mongo DB",

    },
    {
        nameDB: "Firebase",

    },
    {
        nameDB: "Microsoft SQL Server",

    },
    {
        nameDB: "Postgres",

    },
    {
        nameDB: "SQL Lite",

    },

]
export default function Work() {
    
    const { darkMode, toggleDarkMode } = useDarkMode();

    const data = [
        { key: 1, nameproject: "JobSift", img_cover: imagecover, descTitle: "Ứng dụng ứng tuyển và tìm kiếm việc làm", descDetail: "Ứng dụng tìm kiếm việc làm là một nền tảng kết nối giữa người tìm việc và các công ty/đơn vị tuyển dụng. Nó cung cấp một cách thuận tiện để người tìm việc có thể duyệt thông tin về các vị trí công việc có sẵn, tìm kiếm theo ngành nghề, vị trí, địa điểm, hoặc các tiêu chí khác." },
        { key: 2, nameproject: "SoundViet", img_cover: imagecover2, descTitle: "Ứng dụng ứng tuyển và tìm kiếm việc làm", descDetail: "Ứng dụng tìm kiếm việc làm là một nền tảng kết nối giữa người tìm việc và các công ty/đơn vị tuyển dụng. Nó cung cấp một cách thuận tiện để người tìm việc có thể duyệt thông tin về các vị trí công việc có sẵn, tìm kiếm theo ngành nghề, vị trí, địa điểm, hoặc các tiêu chí khác." },
        { key: 3, nameproject: "Socialife", img_cover: imagecover3, descTitle: "Ứng dụng ứng tuyển và tìm kiếm việc làm", descDetail: "Ứng dụng tìm kiếm việc làm là một nền tảng kết nối giữa người tìm việc và các công ty/đơn vị tuyển dụng. Nó cung cấp một cách thuận tiện để người tìm việc có thể duyệt thông tin về các vị trí công việc có sẵn, tìm kiếm theo ngành nghề, vị trí, địa điểm, hoặc các tiêu chí khác." },
        { key: 4, nameproject: "FlySite", img_cover: imagecover4, descTitle: "Ứng dụng ứng tuyển và tìm kiếm việc làm", descDetail: "Ứng dụng tìm kiếm việc làm là một nền tảng kết nối giữa người tìm việc và các công ty/đơn vị tuyển dụng. Nó cung cấp một cách thuận tiện để người tìm việc có thể duyệt thông tin về các vị trí công việc có sẵn, tìm kiếm theo ngành nghề, vị trí, địa điểm, hoặc các tiêu chí khác." },
    ]

    const [listWork, setListWork] = useState()

    useEffect(() => {
        const fetchData = async () => {
            try {
                const projects = await getAllProject();

                setListWork(projects)
                console.log(projects)



            } catch (error) {
                console.error('Error fetching about data:', error);
            }
        };

        fetchData();
    }, []);

    const [dataCollab, setDataColab] = useState(initialData)
    const [dataLanguage, setDataLanguage] = useState(initialDataLG)
    const [dataDatabase, setDataDatabase] = useState(initialDataDB)


    const ProjectItem = ({ key, nameproject, img_cover, descTitle, descDetail, listCollab, listDB, listLang, startDay, endDay, linkPreview }) => {
        const [isShow, setIsShow] = useState(false)
        const clickToShow = () => {
            setIsShow(!isShow)
        }

        const springProps = useSpring({
            opacity: isShow ? 1 : 0,
            transform: isShow ? 'translateY(0)' : 'translateY(20px)',
        });

        const wipe = useSpring({
            opacity: isShow ? 1 : 0,
            transform: isShow ? 'translateX(0)' : 'translateX(20px)',
        })
        return (
            <div className={darkMode ? "item-work_wrap-dark": "item-work_wrap"}  style={{ width: isShow ? '100%' : '' }}>
                <div className="item-work_wrap-image">
                    <div className="wrap-image-cover">
                        {img_cover ? (<img src={img_cover} alt="" />) : (<div className="loading-indicator-container">
                            <div className="loading-indicator"></div>
                        </div>)}
                    </div>
                    {isShow ? (<animated.div style={wipe} className="wrap-content-of-project">
                        {isShow && <div className={darkMode ? "wrap-content-work-dark" : "wrap-content-work"}>

                            <div className="wrap-header-project">
                                <span>{nameproject}: <a href={linkPreview}>Click to Review</a></span>
                            </div>
                            <div className="content-work-date">
                                <div className="work-startdate">
                                    <h4>Ngày bắt đầu: </h4>
                                    <p>{startDay}</p>
                                </div>
                                <div className="work-enddate">
                                    <h4>Ngày kết thúc: </h4>
                                    <p>{endDay}</p>
                                </div>
                            </div>

                            <div className="wrap-table-work">
                                <div className="work-collab">
                                    <h2>Collaborator: </h2>
                                    <table className='table-collab' border="1" cellpadding="5">
                                        <thead>
                                            <tr>
                                                <th>Collaborator name</th>
                                                <th>Position</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {listCollab.map((data, index) => (
                                                <tr key={index} className='row-of-collab'>
                                                    <td>{data.name}</td>
                                                    <td>{data.position}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                                <div className="work-language">
                                    <h2>Programing language: </h2>
                                    <table className='table-collab' border="1" cellpadding="5">
                                        <thead>
                                            <tr>
                                                <th>Name language</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {listLang.map((data, index) => (
                                                <tr key={index} className='row-of-collab'>
                                                    <td>{data.nameLang}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="work-database">
                                    <h2>Database: </h2>
                                    <table className='table-collab' border="1" cellpadding="5">
                                        <thead>
                                            <tr>
                                                <th>Database name</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {listDB.map((data, index) => (
                                                <tr key={index} className='row-of-collab'>
                                                    <td>{data.nameDB}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>}
                    </animated.div>) : (<></>)}
                </div>
                <div className="item-work_wrap-head">

                    <div className="wrap-head-title">
                        <h1>{nameproject}</h1>
                        <h3>{descTitle}</h3>
                    </div>

                    <div className="wrap-head-btnshow">
                        <button className={darkMode ? "button-show-more-dark" : "button-show-more" }onClick={clickToShow}>
                            {isShow ? 'Hidden' : 'Show more'}
                        </button>
                    </div>
                </div>
                {
                    isShow ? (
                        <animated.div style={springProps} className="wrap-descript">
                            {isShow ? (
                                <p>{descDetail}</p>) : (<></>)}
                        </animated.div>
                    ) : (<div></div>)
                }
            </div>

        )

    }




    return (
        <div className="work">
            <div className="item-work">

                {/* {data.map((project) => (
                    <ProjectItem
                        key={project.key}
                        nameproject={project.nameproject}
                        descTitle={project.descTitle}
                        descDetail={project.descDetail}
                        img_cover={project.img_cover}
                    />
                ))} */}

                {
                    listWork ? (listWork.map((project, index) => (
                        <ProjectItem
                            key={index}
                            nameproject={project.nameProject}
                            descTitle={project.briefDes}
                            descDetail={project.description}
                            img_cover={project.avatarProject}
                            listCollab={project.listCollab}
                            listDB={project.listData}
                            listLang={project.listLang}
                            startDay={project.startDate}
                            endDay={project.endDate}
                            linkPreview={project.linkreview}
                        />
                    ))) : (<div className="loading-indicator-container">
                        <div className="loading-indicator"></div>
                    </div>)
                }
            </div>
        </div>

    )
}